module.exports = __webpack_public_path__ + "img/splicing_prograss_four_ss.fa1c995f.png";